/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ActionRequestStateAfterService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'State After\' loaded');
    }
}

export { ActionRequestStateAfterService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestStateAfterService.js